



























import { Component, Vue, Watch, Emit, Prop } from 'vue-property-decorator';
@Component
export default class VariableOneCheckBox extends Vue {
  // private privateInvaildMessage: string = '';
  // private rules: any;
  private values: any = [];
  private checkboxState: any = {};
  private privateTextColor: string = '';
  @Prop() private name!: string;
  @Prop() private value?: any;
  @Prop({default: false}) private readonly?: boolean;
  @Prop({default: false}) private disabled?: boolean;
  @Prop({default: false}) private required?: boolean;
  @Prop() private options!: any;
  @Prop() private index!: number;
  @Prop() private invaildMessage?: string;
  @Prop() private textColor?: string;
  private created() {
    // 確認画面表示のdefault文字色設定
    if (!this.textColor) {
      this.privateTextColor = 'black--text';
    } else {
      this.privateTextColor = this.textColor;
    }
    // 初期値の設定
    this.checkboxState[this.options[0].value] = false;
    if (this.value) {
      this.checkboxState[this.value[0]] = !this.checkboxState[this.value[0]];
    }
    this.returnValue();
  }
  @Emit('input')
  private returnValue() {
    this.values = [];
    for (const i of Object.keys(this.checkboxState)) {
      if (this.checkboxState[i]) {
        this.values.push(i);
      }
    }
    return this.values[0];
  }
  private updateValue(checkValue: string) {
    this.checkboxState[checkValue] = !this.checkboxState[checkValue];
    this.returnValue();
  }
}
